(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerDeleteController', CompanyCustomerDeleteController);

    CompanyCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanyCustomer'];

    function CompanyCustomerDeleteController($uibModalInstance, entity, CompanyCustomer) {
        var vm = this;

        vm.companyCustomer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanyCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
